import React, { useState } from 'react'
const DeclarationText = ({ declarationProps }) => {
    const { policyNumber, moreText, handleMoreText, isRenewalViaDirectDebit } = declarationProps
    const [btnText, setBtnText] = useState('Read full disclaimer')


    const showExtraText = () => {
        if (!moreText) {
            setBtnText('Read Less')
            handleMoreText(true)
        }
        else {
            setBtnText('Read full disclaimer')
            handleMoreText(false)
        }
    }

    return (
        <div>
            {
                isRenewalViaDirectDebit.toLowerCase() == 'y' ?
                    <>
                        {
                            moreText ?
                                <>
                                    <p> By entering the OTP you are giving your consent for debiting your YES Bank Account for making payment of the first premium towards your Insurance policy  {policyNumber}  as well as authorizing YES Bank to auto-debit your YES Bank Account towards the renewal premiums of Policy during subsistence of the Policy</p>
                                    <br />
                                    <p>You hereby further agree and confirm that,
                                        2 days prior to the renewal premium due date YES Bank shall be auto-debiting your YES Bank Account for collection of the renewal premium. However, if due to any reason the auto-debit cannot be executed, then in order to protect lapse of the Policy, YES Bank shall make daily reattempts for debiting the renewal premium upto 30 days grace period and post that every
                                        8 days till 120 days or till successful debit of the renewal premium whichever is earlier. There will be no bounce charges pursuant to this transaction.  <button className='cd-read-more-btn' onClick={showExtraText}>{btnText}</button></p>
                                </>
                                :
                                <>
                                    <p>By entering the OTP you are giving your consent for debiting your YES Bank Account for making payment of the first premium towards your Insurance policy {policyNumber}..
                                        <button className='cd-read-more-btn' onClick={showExtraText}>{btnText}</button>
                                    </p>
                                </>

                        }
                    </> : <p>By entering the OTP you are giving your consent for debiting your YES Bank Account for making payment of the first premium towards your Insurance policy {policyNumber}. </p>

            }

        </div>
    );
}

export default DeclarationText;